import { MessagesSquare, Layers, Factory, Building2, Zap } from "lucide-react";
import { FadeUp, SectionHead } from "../Reveal";

const ITEMS = [
    { icon: MessagesSquare, title: "Atendimento próximo", desc: "Atendimento direto e objetivo, sem burocracia." },
    { icon: Layers, title: "Soluções completas", desc: "Diversos produtos e serviços em um único lugar." },
    { icon: Factory, title: "Produção profissional", desc: "Estrutura própria para diferentes tipos de produção." },
    { icon: Building2, title: "Foco em empresas", desc: "Soluções pensadas para negócios que precisam divulgar e fortalecer sua marca." },
    { icon: Zap, title: "Orçamento fácil", desc: "Solicite seu orçamento diretamente pelo WhatsApp." },
];

export const Differentials = () => (
    <section id="diferenciais" data-testid="differentials-section" className="bg-paper py-20 sm:py-28 lg:py-32">
        <div className="container-x">
            <SectionHead
                tag="05 — Diferenciais"
                title="Por que empresas escolhem a IMPRIMA AKI?"
            />
            <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-6">
                {ITEMS.map((item, i) => (
                    <FadeUp
                        key={item.title}
                        delay={i * 0.07}
                        className={`h-full ${i < 3 ? "lg:col-span-2" : "lg:col-span-3"}`}
                    >
                        <div
                            data-testid={`differential-card-${i}`}
                            className="group h-full rounded-2xl border border-[#E9E9E9] bg-white p-7 transition-all duration-500 hover:-translate-y-1 hover:border-brand/40 hover:shadow-[0_20px_50px_-20px_rgba(13,13,13,0.18)]"
                        >
                            <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-brand">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <div className="mt-4 flex h-11 w-11 items-center justify-center rounded-xl bg-brand-tint text-brand">
                                <item.icon size={20} strokeWidth={1.8} />
                            </div>
                            <h3 className="mt-5 font-display text-lg font-bold tracking-tight text-ink">{item.title}</h3>
                            <p className="mt-2 text-sm leading-relaxed text-smoke">{item.desc}</p>
                        </div>
                    </FadeUp>
                ))}
            </div>
        </div>
    </section>
);
